<script>
// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
/* eslint-disable */
import "vue3-carousel/dist/carousel.css";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import CardResultados from "./CardResultados.vue";
import CarouselResultados from "../../../../components/CarouselResultados.vue";

export default {
	async mounted() {
		await this.$store.dispatch("findUltimosResultados");
		window.addEventListener("resize", () => {
			this.screen_width = window.innerWidth;
		});
	},
	data: () => {
		return {
			screen_width: window.innerWidth,
			sponsors: [],
		};
	},
	components: {
		CardResultados,
		Carousel,
		Navigation,
		Slide,
		CarouselResultados,
	},
	methods: {
		toSend(item) {
			this.$router.push(item);
		},
		parseDate(date) {
			if (date == null) return "indefinido";
			let _date = new Date(date);
			let day =
				_date.getDate() == 31 ? _date.getDate() : _date.getDate() + 1;
			let month =
				_date.getMonth() == 12
					? _date.getMonth()
					: _date.getMonth() + 1;

			return `${day}/${month}`;
		},
	},
	computed: {
		resultados() {
			return this.$store.getters.ultimos_resultados;
		},
		itemsMostrados() {
			if ( this.screen_width > 768 )
				return 3;
			else if ( this.screen_width > 576 )
				return 2;
			else 
				return 1;
		},
	},
};
</script>

<template>
	<div class="row-6">
		<h3 class="m-2 line-height-1 text-center">
			<span>Resultados</span>
		</h3>

		<template v-if="resultados">
			<template v-if="resultados.length">
				<template v-for="resultado in resultados" :key="resultado">
					<a 
						:href="`/resultados/estructura?torneo=${resultado[0].torneo_cod}&calendario=${resultado[0].calendario_id}`" 
						target="_blank"
					>
						<li 
							class="list-group-item list-group-item-action"
						>
							<span> {{ resultado[0].torneo_nombre }} </span>
							<i>{{ parseDate(resultado[0].fecha_desde) }} al {{ parseDate(resultado[0].fecha_hasta) }}</i>
						</li>
					</a>
				</template>
			</template>
		</template>

		<a href="/exposiciones/estructura">
			<button
				type="button"
				class="btn btn-primary"
				style="margin-top: 0.5rem"
			>
				Ver todos los resultados
			</button>
		</a>
	</div>
</template>

<style scoped>
li {
	display: flex;
	cursor: pointer;
}

li > span {
	width: 100%;
	font-weight: 600;
}

li > i {
	width: 100%;
	text-align: right;
}

.carousel__prev,
.carousel__next {
	box-sizing: content-box;
	position: absolute;
	background-color: #65c178;
}

.carousel__prev {
	left: -20px;
}

.carousel__next {
	right: -20px;
}

@media (max-width: 768px) {
	.carousel__prev {
		left: 0px;
	}

	.carousel__next {
		right: 0px;
	}
}

.btn-table-go {
	display: flex;
	justify-content: flex-end;
}
</style>

<style scoped>
.publicidad {
	width: 100%;
	margin: auto;
	margin-top: 1em;
}

@media screen and (min-width: 768px) {
	.publicidad {
		width: 768px;
	}
}

@media screen and (max-width: 768px) {
	.resultados-title {
		text-align: center;
	}
	.btn-resultado {
		margin: auto;
		margin-top: 1em;
	}
}
</style>
